import React from "react";
import moment from "moment";
import { Card, MenuItem } from "@mui/material";

import { endpoint } from "../../common/constant";
import {
  fetchAllPromisedData,
  fetchAllPostPromisedData,
  capitalize,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { dropdownMapping } from "../../edpOps/constant/batch-search";
import APopover from "../../common/a-popover";
import AChip from "../../common/chip/AChip";

export const DEFAULT_FILTER_STATE = {
  designation: [],
  department: [],
  region: [],
  project: [],
  source: [],
  status: [],
  joiningDateFrom: "",
  joiningDateTo: "",
};

export const fetchOnInitialLand = async () => {
  const response = await Promise.allSettled([
    getEmployeeCountDetails(),
    searchEmployeeDetails({}),
    getEmployeeDetailLogs(),
  ]);

  return {
    userAnalytics: response[0].status === "rejected" ? {} : response[0].value,
    userList: response[1].status === "rejected" ? [] : response[1].value,
    userLogs: response[2].status === "rejected" ? [] : response[2].value,
  };
};

export const getEmployeeCountDetails = async () => {
  const res = await fetchAllPromisedData(
    `${endpoint?.getEmployeeCountDetails}`
  );

  if (res.totalEmployeeWithUserCount >= 0) {
    return res;
  }

  return null;
};

export const searchEmployeeDetails = async ({ payload = {}, page = 0 }) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.searchEmployeeDetails}?offset=${page}&limit=50`,
    {
      ...payload,
    },
    "post"
  );

  return response?.data || {};
};

export const getEmployeeDetailLogs = async (page = 0) => {
  const res = await fetchAllPromisedData(
    `${endpoint?.getEmployeeDetailLogs}?operationType=EMPLOYEE_OPERATION&offset=${page}&limit=50`
  );

  if (res.empoloyeeLogDetailList.length) {
    return res;
  }

  return {};
};

export const TableHeaderActions = ({ handleClose, menuItems }) => {
  return (
    <Card style={{ padding: "0.7rem 0.4rem" }}>
      {menuItems.map(({ text, handleClick }, index) => {
        return (
          <MenuItem
            className="d-flex py-2 text-sm"
            style={{ gap: "16px", fontWeight: 700 }}
            onClick={() => {
              handleClick();
              handleClose();
            }}
            key={index}
          >
            <span>{text}</span>
          </MenuItem>
        );
      })}
    </Card>
  );
};

export const ViewUserMappingPopover = ({ userId, emailId }) => {
  const [userProjects, setUserProjects] = React.useState([]);
  const [isFetching, setIsFetching] = React.useState(false);

  const getUserProjects = async () => {
    setIsFetching(true);

    const res = await fetchAllPromisedData(
      `${endpoint.permission.getUsersPermissionDetails}?userId=${userId}&emailId=${emailId}`
    );

    setUserProjects(res.userProjectMappingResponseList);

    setIsFetching(false);
  };

  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <span
          onClick={(e) => {
            onClick(e);
            getUserProjects();
          }}
          style={{ cursor: "pointer" }}
          className="text-bold text-primary"
        >
          View
        </span>
      )}
      menuComponent={(closeForm) => (
        <>
          <Card className="mb-0 regular-body label-color">
            <div className="p-3">
              {isFetching ? (
                "Loading..."
              ) : (
                <div className="d-flex flex-column">
                  <h4 style={{ color: "#afafaf" }}>USER ID MAPPING</h4>

                  <table>
                    {userProjects.map(
                      ({ userId, projectDispValue, status }) => (
                        <tr className="mt-2">
                          <td className="pr-4 text-nowrap text-bold">
                            {userId}
                          </td>
                          <td className="pr-4">{projectDispValue || "-"}</td>
                          <td>
                            <AChip
                              label={capitalize(status)}
                              success={status?.toUpperCase() === "ACTIVE"}
                            />
                          </td>
                        </tr>
                      )
                    )}
                  </table>
                </div>
              )}
            </div>
          </Card>
        </>
      )}
      transformOriginVertical="center"
      transformOriginHorizontal="left"
    />
  );
};

export const getFormattedDate = (date) => {
  return moment(date).format("DD/MM/YYYY");
};

export const getUpdatedTime = (date) => {
  return moment(date).format("hh:mm A");
};

export const LastUpdatedDetails = (lastUpdatedOn, lastUpdatedBy) => {
  if (lastUpdatedBy)
    return `${getFormattedDate(lastUpdatedOn)} at ${getUpdatedTime(
      lastUpdatedOn
    )} by ${lastUpdatedBy}`;

  return `${getFormattedDate(lastUpdatedOn)} at ${getUpdatedTime(
    lastUpdatedOn
  )}`;
};

export const getUserMgmtFiltersDropdowns = async () => {
  const p = await Promise.all([
    dropdownMapping(endpoint.jobTitle.getAll, "designation"),
    dropdownMapping(endpoint.departmentType.getAll, "department"),
    dropdownMapping(endpoint.region.getAllActive, "regionDispValue"),
    dropdownMapping(endpoint.projectDetails.getAllProject, "project"),
  ]);
  return {
    designation: p[0],
    department: p[1],
    regions: p[2],
    project: p[3],
  };
};

export const SEARCH_BY = [
  {
    key: "employeeName",
    value: "By Name",
  },
  {
    key: "userId",
    value: "By User ID",
  },
  {
    key: "employeeId",
    value: "By Employee ID",
  },
];

export const SOURCE_DROPDOWN = [
  {
    label: "CSV",
    value: "CSV",
  },
  {
    label: "Hono",
    value: "HONO",
  },
];

export const STATUS_DROPDOWN = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
  {
    label: "Resigned",
    value: "resigned",
  },
];

export const REACT_ICONS_STYLE = {};
